import { render, staticRenderFns } from "./SummaryTabButtonsCustomer.vue?vue&type=template&id=54be8f58&scoped=true&"
import script from "./SummaryTabButtonsCustomer.vue?vue&type=script&lang=js&"
export * from "./SummaryTabButtonsCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be8f58",
  null
  
)

export default component.exports